import * as THREE from 'three'
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import EventEmitter from "./EventEmitter";
import Experience from '../Experience.js'

export default class Resources extends EventEmitter {
    constructor(sources){
        super();

        this.sources = sources;
        this.experience = new Experience()

        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0
        this.progressBarContainer = document.querySelector(
            ".progress-bar-container"
          );
          this.canvas = document.querySelector(".webgl");
      
          this.loadingKnapp = document.getElementById("loading-knapp");
          this.progressBar = document.getElementById("progress-bar");

        this.setLoaders()
        this.startLoading()
        
    }
    setLoaders(){ 
        this.loaders = {}
        this.loaders.gltfLoader = new GLTFLoader()
        this.loaders.textureLoader = new THREE.TextureLoader()
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader()
        this.loaders.audioLoader = new THREE.AudioLoader();
        this.loaders.RGBELoader = new RGBELoader();
    }
    startLoading()
    {
        // Load each source
        for(const source of this.sources){
            if(source.type === 'gltfModel'){
                this.loaders.gltfLoader.load(source.path,(file) =>{
                        this.sourceLoaded(source, file)
                    })
            }else if(source.type === 'texture'){
                this.loaders.textureLoader.load(source.path,(file) =>{
                        this.sourceLoaded(source, file)
                    })
            }else if(source.type === 'cubeTexture'){
                this.loaders.cubeTextureLoader.load(source.path,(file) =>{
                        this.sourceLoaded(source, file)
                    })
            } else if (source.type === "music") {
                this.loaders.audioLoader.load(source.path, (file) => {
                  this.sourceLoaded(source, file);
                });
            } else if (source.type === "hdr") {
                this.loaders.RGBELoader.load(source.path, (file) => {
                  this.sourceLoaded(source, file);
                });
              }

        }
    }
    sourceLoaded(source, file){
        this.items[source.name] = file

        this.loaded++
        // console.log((this.loaded / this.toLoad) * 100);
        this.progressBar.value = (this.loaded / this.toLoad) * 100;

        if(this.loaded === this.toLoad){
            this.loadingKnapp.style.display = "inline";
            const el = this.progressBarContainer;
            const fullScreen = this.canvas;
            const trigStartDivTing = this.experience;

            this.loadingKnapp.addEventListener("click", function () {
                el.style.display = "none";
                // fullScreen.requestFullscreen();

                trigStartDivTing.resources.trigger("startDivTing");
            });

            this.trigger('ready')
        }
    }
}